function loadCartModule()
{
  var legacyCartModule = window.legacyCartModule;
  var modernCartModule = window.modernCartModule;

  var cartModule = modernCartModule;
  var cartLabel = "MODERN";

  var currentUrl = new URL(window.location.href);
  var currentUrlParams = new URLSearchParams(currentUrl.search);

  var hasModernCartParameter = currentUrlParams.get('modernCart');
  var hasModernCartConfig = localStorage.getItem('cartModule') === 'modern';

  if (hasModernCartParameter || hasModernCartConfig)
  {
    cartModule = modernCartModule;
    localStorage.setItem('cartModule', 'modern');
    hasModernCartConfig = true;
    cartLabel = "MODERN";
  }

  if (currentUrlParams.get('legacyCart'))
  {
    cartModule = legacyCartModule;
    localStorage.setItem('cartModule', 'legacy');
    cartLabel = "LEGACY";
  }

  console.log("USING " + cartLabel + " CART");

  console.log("Cart Script: " + cartModule);
  $.getScript(cartModule);
}


loadCartModule();